"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const runtime_1 = require("./runtime");
const runtime_api_1 = require("../runtime-api");
function mapModuleImplementation(ns, implementations) {
    return implementations.map(x => runtime_api_1.implementation(x.implementation, ns, x.name, ...x.parameters));
}
let ModularizedRuntime = class ModularizedRuntime {
    constructor(modules) {
        const implementations = modules.reduce((a, b) => ([...a, ...mapModuleImplementation(b.ns, b.implementations)]), []);
        this.runtime = new runtime_1.Runtime(implementations);
    }
    execute(code) {
        return this.runtime.execute(code);
    }
};
ModularizedRuntime = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.multiInject(runtime_api_1.DslRuntimeModuleSymbol)),
    __metadata("design:paramtypes", [Array])
], ModularizedRuntime);
exports.ModularizedRuntime = ModularizedRuntime;
//# sourceMappingURL=modularized-runtime.js.map